module.exports = __webpack_public_path__ + "img/image_part_008.8c350193.jpg";